(function () {
  'use strict';

  window.DOMUtils = window.DOMUtils || {};

  DOMUtils.debug = function () {
    try {
      return (
        !!window.DEBUG ||
        !!window.__DOM_UTILS_DEBUG__ ||
        localStorage.getItem('netwrck_dom_utils_debug') === '1'
      );
    } catch (_) {
      return false;
    }
  };

  DOMUtils.safeQuerySelector = function (selector, context) {
    context = context || document;
    try {
      return context.querySelector(selector);
    } catch (e) {
      if (DOMUtils.debug()) {
        console.warn('SafeQuerySelector error for', selector, ':', e);
      }
      return null;
    }
  };

  DOMUtils.safeQuerySelectorAll = function (selector, context) {
    context = context || document;
    try {
      return context.querySelectorAll(selector);
    } catch (e) {
      if (DOMUtils.debug()) {
        console.warn('SafeQuerySelectorAll error for', selector, ':', e);
      }
      return [];
    }
  };

  DOMUtils.domReady = function (fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  DOMUtils.showDialog = function (dialogSelector) {
    var dialog =
      typeof dialogSelector === 'string'
        ? DOMUtils.safeQuerySelector(dialogSelector)
        : dialogSelector;

    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      console.error(
        'Dialog not found or showModal not available:',
        dialogSelector
      );
    }
  };

  DOMUtils.closeDialog = function (dialogSelector) {
    var dialog =
      typeof dialogSelector === 'string'
        ? DOMUtils.safeQuerySelector(dialogSelector)
        : dialogSelector;

    if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  };

  DOMUtils.createElement = function (tag, attributes, content, parent) {
    var element = document.createElement(tag);

    if (attributes) {
      Object.keys(attributes).forEach(function (key) {
        if (key === 'className') {
          element.className = attributes[key];
        } else {
          element.setAttribute(key, attributes[key]);
        }
      });
    }

    if (content) {
      if (typeof content === 'string') {
        element.innerHTML = content;
      } else {
        element.appendChild(content);
      }
    }

    if (parent) {
      parent.appendChild(element);
    }

    return element;
  };

  DOMUtils.toggleVisibility = function (elementSelector, show) {
    var element =
      typeof elementSelector === 'string'
        ? DOMUtils.safeQuerySelector(elementSelector)
        : elementSelector;

    if (!element) return;

    if (typeof show === 'boolean') {
      element.style.display = show ? '' : 'none';
    } else {
      element.style.display = element.style.display === 'none' ? '' : 'none';
    }
  };

  DOMUtils.scrollIntoView = function (elementSelector, options) {
    var element =
      typeof elementSelector === 'string'
        ? DOMUtils.safeQuerySelector(elementSelector)
        : elementSelector;

    if (element && element.scrollIntoView) {
      element.scrollIntoView(
        options || { behavior: 'smooth', block: 'center' }
      );
    }
  };
})();
